/* eslint-disable camelcase */
/* eslint-disable no-fallthrough */
import { api } from '../utils/api';
import { load58AppSDK } from '../utils/load';
import versionCompare from '../utils/versionCompare';
import cookie from '@/utils/cookie';
import track from '../utils/track';
import trackNew from '../utils/trackNew';

const ua = window.navigator.userAgent;
const is58App = ua.includes('WUBA') || ua.includes('WBUA') || cookie.get('58ua') === '58app';

export const handlerDelivery = async({ complete, deliverySuccess, trackLog, ...params }) => {
    console.log('校验全网推投递参数--', params);
    if (params.adType === '41') {
        // 全网推异步投递
        const qwtRes = await api.qwtDelivery({ ...params, type: params.qwtType });
        try {
            await track({
                d: {
                    page_type: params.type === 'Dialog' ? 1000 : 1001,
                    element_id: 82,
                    request_param: params,
                    element_param: qwtRes
                }
            });
        } catch (error) {
        } finally {
            if (qwtRes.code === 1) {
                deliverySuccess && deliverySuccess({ code: 1, msg: qwtRes.message });
                complete && complete({ code: 1, oriCode: qwtRes.code });
                trackNew({
                    action: 1005,
                    element_id: 11,
                    module_id: 'other',
                    element_param: { type: 'success' }
                }, trackLog);
            } else {
                trackNew({
                    action: 1005,
                    element_id: 11,
                    module_id: 'other',
                    element_param: { type: 'fail', content: `${qwtRes.code}-${qwtRes.message}` }
                }, trackLog);
                const msg = qwtRes.msg || qwtRes.message || '网络异常，请稍后重试';
                complete && complete({ code: 0, msg, oriCode: qwtRes.code });
            }
        }
    } else {
        // 其余产品投递
        const delRes = await api.delivery(params);
        /**
         * 投递结果上报
         */
        try {
            await track({
                d: {
                    page_type: params.type === 'Dialog' ? 1000 : 1001,
                    element_id: 82,
                    request_param: params,
                    element_param: delRes
                }
            });
        } catch (error) {
        } finally {
            if (delRes.code === 12000018) {
                deliverySuccess && deliverySuccess({ code: 1, msg: delRes.msg });
                complete && complete({ code: 1, oriCode: delRes.code });
                trackNew({
                    action: 1005,
                    element_id: 11,
                    module_id: 'other',
                    element_param: { type: 'success' }
                }, trackLog);
            } else if (delRes.code === 12000005) {
                trackNew({
                    action: 1005,
                    element_id: 11,
                    module_id: 'other',
                    element_param: { type: 'fail', content: `${delRes.code}-${delRes.msg}` }
                }, trackLog);
                // eslint-disable-next-line no-unsafe-finally
                return { type: 'VerifyPhone', resumeId: params.resumeId };
            } else {
                trackNew({
                    action: 1005,
                    element_id: 11,
                    module_id: 'other',
                    element_param: { type: 'fail', content: `${delRes.code}-${delRes.msg}` }
                }, trackLog);
                const msg = delRes.msg || delRes.message || '网络异常，请稍后重试';
                complete && complete({ code: 0, msg, oriCode: delRes.code });
            }
        }
    }


};

export const handlerDeliveryCheck = async(options, initCb) => {
    const res = await api.deliveryCheck();
    console.log('投递校验结果--', res);
    console.log('投递校验参数--', options);
    // TODO: 这个接口是校验什么的？是否有唯一简历么，那全网推就需要修改为透传简历id
    let cbConfig = null;
    switch (res.code) {
    case 12000000: // 进行投递
        cbConfig = await handlerDelivery({ ...options, wbtk: '', ...res.data });
        break;
    case 12000001: // 有多份全职简历，显示简历列表
        if (options.adType === '41') {
            cbConfig = await handlerDelivery({ ...options, wbtk: '', ...res.data });
        } else {
            cbConfig = { type: 'ResumeSel', resumeList: res.dataArray || [] };
        }
        break;
    case 12000002:
        if (is58App) {
            await load58AppSDK();
            if (versionCompare(window.WBAPP.common.appVersion, '<', '8.1')) { // 8.1及以上去掉登录前置
                window.WBAPP.invoke('login');
                break;
            }
        }
    default:
        cbConfig = {};
    }

    if (cbConfig) {
        initCb(cbConfig);
    }
};
